import { format } from "date-fns";

export default function DateComponent({ dateString }) {
  return (
    <time className="inline-block" dateTime={dateString}>
      {format(new Date(dateString), "yyyy")}
    </time>
  );
}
